export const ProductTabsController = () => {

  enquire.register("screen and (max-width: 720px)", {
    match: function () {
      $('.js-tab-flyout.active').removeClass('active');
      $('.js-tab-toggle.active').removeClass('active');
      $('.m-tab-content.active').removeClass('active');

      $('.js-tab-flyout').first().addClass('active');
      $('.js-tab-toggle').first().addClass('active');
      $('.m-tab-content').first().addClass('active');
    },
    unmatch: function () {
      $('.js-tab-flyout.active').removeClass('active');
      $('.js-tab-toggle.active').removeClass('active');
      $('.m-tab-content.active').removeClass('active');

      $('.js-tab-flyout').first().addClass('active');
      $('.js-tab-toggle').first().addClass('active');
      $('.m-tab-content').first().addClass('active');
    }
  });

  $('.js-tab-toggle').on('click', (e) => {
    e.preventDefault();
    let currentTarget = e.currentTarget;
    let target = $(currentTarget).data('target');

    $('.js-tab-toggle.active').removeClass('active');
    $('.m-tab-content.active').removeClass('active');

    $(currentTarget).addClass('active');
    $(target).addClass('active');
  });

  $('.js-tab-flyout').on('click', (e) => {
    e.preventDefault();
    let currentTarget = e.currentTarget;
    let target = $(currentTarget).data('target');

    $(currentTarget).toggleClass('active');
    $(target).toggleClass('active');
  });
}



// WEBPACK FOOTER //
// ./src/js/controllers/ProductTabsController.js